import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_CONSTANTS } from '../../constant';
import quizAssessmentBaseQuery from 'service/quizAssessmentBaseQuery/quizAssessmentBaseQuery';

type ApiResponse<T> = {
  data: T;
  status: number;
  message?: string;
};

export const quizAssessmentQuery = createApi({
  reducerPath: 'quizAssessmentQuery',
  baseQuery: quizAssessmentBaseQuery,
  endpoints: builder => ({
    findQuestion: builder.query({
      query: () => ({
        url: ENDPOINT_CONSTANTS.QUIZ,
        method: 'GET'
      }),
      transformResponse: <T>(
        response: ApiResponse<T> | undefined
      ): T | undefined => {
        return response?.data;
      }
    }),
    submitQuestionAnswer: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${ENDPOINT_CONSTANTS.SUBMIT_QUESTION_ANSWER}/${id}`,
        method: 'POST',
        body
      })
    }),
    submitQuiz: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${ENDPOINT_CONSTANTS.SUBMIT_QUIZ}/${id}`,
        method: 'POST',
        body
      })
    }),
    endQuiz: builder.mutation({
      query: isExpired => {
        let url = ENDPOINT_CONSTANTS.END_QUIZ;
        if (isExpired) {
          url += '?isExpired=true';
        }
        return {
          url,
          method: 'POST',
          body: {}
        };
      }
    })
  })
});

export const {
  useLazyFindQuestionQuery,
  useSubmitQuestionAnswerMutation,
  useFindQuestionQuery,
  useSubmitQuizMutation,
  useEndQuizMutation
} = quizAssessmentQuery;
